<template>
  <button v-if="soundSupported"
          @click="micClick"
          :class="{ 'mic-active': recognizing }">
    <MicrophoneSvg class="mic-svg"/>
  </button>
</template>

<script setup>
import MicrophoneSvg from "@/assets/svg-vue/general/mic2.svg"
import i18n from "@/lang/i18n"
import { onMounted, ref } from "vue"

const props = defineProps({
  modelValue: {},
})

const emit = defineEmits(['update:modelValue'])

let recognizer = null
let initialVal = ''
let timer = null
const soundSupported = ref(false)
const recognizing = ref(false)

const startTimer = () => {
  timer = setTimeout(() => {
    recognizer.stop()
  }, 2000)
}

// stops after 2 seconds without results
const prolongTimer = () => {
  if(timer) { clearTimeout(timer) }
  startTimer()
}

const micClick = () => {
  if (recognizing.value) {
    recognizer.stop()
    return
  }
  // a quick second click comes before onstart, when the recognition is already started
  try {
    recognizer.start()
  } catch (e) {
    if(e?.name !== 'InvalidStateError') throw e
  }
}

const startRecognizer = () => {
  initialVal = props.modelValue
  recognizing.value = true
  startTimer()
}

const endRecognizer = () => {
  recognizing.value = false
}

// the recognized text is appended to the value it had when the recognition started
const resultRecognizer = (e) => {
  prolongTimer()
  let v = initialVal ?? ''
  // var interim_transcript = ''
  // var final_transcript = ''
  if (typeof(e.results) == 'undefined') {
    recognizer.stop()
    return
  }
  for (var i = e.resultIndex; i < e.results.length; ++i) {
    if(e.results[i][0].transcript) {
      v += e.results[i][0].transcript
    }
    // if (e.results[i].isFinal) {
    //   v += e.results[i][0].transcript
    // final_transcript += e.results[i][0].transcript;
    // this.$emit('update:modelValue', final_transcript)
    // } else {
    //   v += e.results[i][0].transcript
    // interim_transcript += e.results[i][0].transcript;
    // this.$emit('update:modelValue', interim_transcript)
    // }
    // console.log(v)
    emit('update:modelValue', v)
  }
}

onMounted(() => {
  if (!window || !('webkitSpeechRecognition' in window)) {
    soundSupported.value = false
    return
  }
  soundSupported.value = true
  recognizer = new window.webkitSpeechRecognition()
  recognizer.continuous = true
  recognizer.interimResults = true
  recognizer.lang = i18n.global.locale

  // recognizer.onstart = function () {
  // this.start
  // recognizing = true;
  // button.style.color = 'red';
  // finalText = element[0].value;
  // restartTimer();
  // };
  recognizer.onstart = startRecognizer
  recognizer.onend = endRecognizer
  recognizer.onresult = resultRecognizer

  // recognizer.onend = function () {
  //   recognizing = false;
  //   button.style.color = '';
  //   clearTimeout(timeout);
  // };
})
</script>

<style scoped lang="scss">
.mic-svg {
  width: 32px;
  height: 32px;
  fill: #6C757D;
}
.mic-active {
  .mic-svg {
    fill: $blue-color;
  }
}
</style>
